<template>
  <div>
    <component
      :is="userHavePhone ? 'div' : 'a'"
      :href="hrefLink"
      class="d-flex align-items-center cursor-pointer"
      @click="makeACall"
    >
      <span class="font-weight-bold">{{ outbound_number | VMask("+#(###)###-##-##") }}</span>    
      <b-icon
        :icon="loading ? 'arrow-repeat' : 'telephone-fill'"
        :font-scale="size"
        variant="success"
        flip-h
        class="mx-1"
        :animation="loading ? 'spin' : ''"
      />      
    </component>
    <b-modal
      id="confirm"
      hide-header
      ok-title="Уже запущен"
      cancel-title="Закрыть"
      @ok="
        setCookie('linkus', 'enabled', { 'max-age': 14400 });
        makeACall();
      "
    >
      Убедитесь, что приложение Linkus для звонков включено, и вы в нем
      авторизованы!
    </b-modal>

    <b-modal
      id="statusCall"
      centered
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
    >
      <div class="text-center">
        <h4 class="mb-4">Как прошел звонок:</h4>
        <b-form-textarea
          class="mb-3"
          v-model="comment"
          placeholder="Комментарий к звонку...."
          rows="4"
          no-resize
        ></b-form-textarea>
        <div style="display: flex !important;
                    flex-flow: row wrap;
                    align-items: center;
                    gap: 12px;
                    justify-content: flex-end;
                    flex-direction: row;
                    flex-wrap: wrap;">
          <b-button
            variant="success"
            @click="submitStatusCall('Accepted')"
            >Дозвонился</b-button
          >
          <b-button
            variant="primary"
            @click="submitStatusCall('Busy')"
            >Занято</b-button
          >
          <b-button
            variant="primary"
            @click="submitStatusCall('Not accepted')"
            >Не взял трубку</b-button
          >
          <b-button
            variant="primary"
            @click="submitStatusCall('Error')"
            >Ошибка соединения</b-button
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { API_USER_CALL, API_MAKE_A_CALL } from "../../constants/api";
import cookiesHelpes from "../../mixins/cookies/cookiesHelpers.js";

export default {
  mixins: [cookiesHelpes],

  props: {
    size: {
      type: Number,
      default: 1.0,
    },

    company_id: {
      type: Number,
      default: null,
    },

    outbound_number: {
      type: String,
      required: true,
      default: "",
    },

    target_type: {
      type: String,
      default: null,
    },

    target_id: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      loading: false,
      comment: "",
      outbound_id: null,
      yeastar_phone_number: null,
    };
  },

  computed: {
    ...mapGetters("auth", ["currentUser"]),

    userHavePhone() {
      return this.currentUser.yeastar_phone_number !== null;
    },

    hrefLink() {
      return !this.userHavePhone ? `tel:${this.outbound_number}` : null;
    },
  },

  methods: {
    makeACall() {
      if (this.checkLinkus() && this.userHavePhone) {
        this.loading = true;
        let api_data = {
          outbound_number: this.outbound_number,
        };
        if (this.company_id !== null) {
          api_data.company_id = this.company_id;
        }
        if (this.target_type !== null) {
          api_data.target_type = this.target_type;
        }
        if (this.target_id !== null) {
          api_data.target_id = this.target_id;
        }
        // Миша, данные нужны для комментирования
        axios
          .post(API_MAKE_A_CALL, api_data)
          .then(({ data }) => {
            if (this.getCookie("linkus") === "enabled") {
              this.$bvModal.show("statusCall");
              this.outbound_id = data.outbound_id;
              this.yeastar_phone_number = data.yeastar_phone_number;
            }
          })
          .finally(() => {
            this.loading = false;
            this.$emit("callWasMade");
          });
      }
    },

    async submitStatusCall(status) {
      const params = {
        status,
        comment: this.comment,
        yeastar_phone_number: this.yeastar_phone_number,
        outbound_id: this.outbound_id,
        company_id: this.company_id,
        outbound_number: this.outbound_number,
        target_id: this.target_id,
        target_type: this.target_type,
        user_id: this.currentUser.id,
      };

      await axios.post(API_USER_CALL, params);
      this.comment = "";
      this.outbound_id = null;
      this.number = null;
      this.yeastar_phone_number = null;
      this.$emit("callWasMade");
      this.$bvModal.hide("statusCall");
    },

    checkLinkus() {
      if (this.getCookie("linkus") === "enabled") {
        return true;
      } else {
        this.$bvModal.show("confirm");
      }
    },
  },
};
</script>
